import { render } from "./repeatFw.vue?vue&type=template&id=5b6d4824&scoped=true"
import script from "./repeatFw.vue?vue&type=script&lang=js"
export * from "./repeatFw.vue?vue&type=script&lang=js"

import "./repeatFw.vue?vue&type=style&index=0&id=5b6d4824&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6d4824"]])

export default __exports__